import React from "react";
import { Link } from "react-router-dom";

const PageTitle = ({ motherMenu, childMenu, activeMenu, childMenuRoute }) => {
	let path = window.location.pathname.split("/");

	// Por padrão, no mínimo, vem com duas posições. Ex.: Module/FormList.
	// Mas caso venha um terceiro, que no caso seria o New, ele trata também. Ex.: Modulo/FormList/new.
	let module = path[path.length - 2];
	let listForm = path[path.length - 1];
	let newForm = null;

	// Padrão sem o editar.
	if (path.length > 3) {
		module = path[path.length - 3];
		listForm = path[path.length - 2];
		newForm = path[path.length - 1];
	}

	// Geralmente no editar que passa o id do registro
	// e portanto cria um número de path a mais.
	if (path.length > 4) {
		module = path[path.length - 4];
		listForm = path[path.length - 3];
		newForm = path[path.length - 2];
	}
	
	const showChildMenu = childMenu !== undefined && (newForm !== null || childMenuRoute !== undefined);

	return (
		<div className="page-titles mx-0">
			<div className="page-title-heading">
				<span className="page-title-heading__section">{motherMenu}</span>
				<h1 className="page-title-heading__title">{activeMenu}</h1>
			</div>

			<nav className="page-title-breadcrumb" aria-label="breadcrumb">
				<ol className="breadcrumb">
					<li className="breadcrumb-item">{motherMenu}</li>
					{
						!showChildMenu ?
							<li className="breadcrumb-item active" aria-current="page">{activeMenu}</li> :
							<>
								<li className="breadcrumb-item"><Link to={childMenuRoute || `/${module}/${listForm}`}>{childMenu}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">{activeMenu}</li>
							</>
					}
				</ol>
			</nav>
		</div>
	);
};

export default PageTitle;
